import React, {useEffect, useMemo} from "react";
import {LoadingSelect, LoadingSelectProps} from "~/apps/packages/auto-visits/components/AutoVisitForm/LoadingSelect";
import {useTimeSlots} from "~/apps/packages/auto-visits/hooks";
import {TimeSlot} from "~/apps/packages/auto-visits/queries";
import moment from "moment";
import {distinctByField} from "~/apps/packages/auto-visits/utils";


type Value = Pick<TimeSlot, "ID" | "StartTime" | "EndTime">


export type TimeSlotSelectProps = Omit<LoadingSelectProps, "onChange"> & {
    carrierId: string
    serviceIds: string[]
    cargoIds: string[]
    autoVisitDate?: Date
    autoVisitId?: string
    value?: Value
    onChange?: (value: Value) => any
    additionalOptions?: Value[]
}


function formatTime(s: string) {
    return moment(s, "HH:mm:ss").format("HH:mm");
}


export const TimeSlotSelect = (props: TimeSlotSelectProps) => {
    const { carrierId, serviceIds, cargoIds, autoVisitId, autoVisitDate, onChange, value, additionalOptions, ...otherProps} = props;
    const {data, loading} = useTimeSlots({carrierId, serviceIds, cargoIds, autoVisitId, autoVisitDate});

    const availableValues = useMemo(() => {
        const availableValues: Value[] = [].concat(data).concat(additionalOptions).filter(Boolean);
        return distinctByField(availableValues, "ID").sort((a, b) => {
            return 0;
        });
    }, [data, additionalOptions]);

    const isValid = useMemo(() => {
        return loading || !value || availableValues.find(item => item.ID == value.ID);
    }, [loading, value, availableValues]);

    const handleChange = (e) => {
        const value = availableValues.find(item => item.ID == e.target.value);
        onChange && onChange(value);
    }

    const options = useMemo(() => {
        if (!data?.length) {
            return [];
        }
        return [
            {
                value: "",
                title: <>Не выбран</>
            },
            ...availableValues?.map(slot => ({
                value: slot.ID,
                title: (
                    <>
                        {formatTime(slot.StartTime)}
                        &ndash;
                        {formatTime(slot.EndTime)}
                    </>
                )
            }))
        ]
    }, [data, availableValues])

    useEffect(() => {
        if (!isValid) {
            onChange && onChange(null);
        }
    }, [isValid])

    return (
        <LoadingSelect
            label="Слот"
            placeholder="Выбрать"
            {...otherProps as LoadingSelectProps}
            value={value ? value.ID : ""}
            onChange={handleChange}
            loading={loading}
            options={options}
            empty="Нет доступных слотов"
        />
    )
}
